import { Link } from 'react-router-dom';

const HardDiskSection = () => (
  <section className="py-14 bg-gray-900">
    <div className="max-w-7xl mx-auto px-4 md:px-6">
      <div className="flex flex-col lg:flex-row items-start gap-10 lg:gap-16">
        {/* Left image */}
        <div className="w-full lg:w-1/2">
          <img
            src="/images/Hard-Drive-Destruction-Service.jpg"
            alt="Certified hard drive destruction service electronic media shredding"
            className="w-full h-[280px] md:h-[340px] object-cover object-center rounded-xl"
            loading="lazy"
            width={600}
            height={420}
          />
        </div>
        {/* Right text */}
        <div className="w-full lg:w-1/2">
          <div className="inline-block bg-[#1B6B3A] text-white text-xs font-bold px-3 py-1 rounded mb-3">
            Certified Information Destruction
          </div>
          <h2 className="text-2xl md:text-3xl font-extrabold text-white mb-5 leading-tight">
            Hard Drive Destruction<br />Service
          </h2>
          <p className="text-gray-300 text-sm leading-relaxed mb-4">
            Electronic media will be destroyed using our state-of-the-art electronic media shredder. Our shredder destroys your hard drives, cell phones, and other electronic storage products and materials in seconds, making your private information secure and irretrievable.
          </p>
          <p className="text-gray-300 text-sm leading-relaxed mb-5">
            Our hard drive destruction services keep your business compliant. Our facility and electronic shredding equipment meet all of the strictest data privacy laws including:
          </p>

          {/* Walk in service */}
          <div className="bg-white/10 rounded-lg p-4 mb-5">
            <div className="font-bold text-white text-sm mb-3">Walk In Service</div>
            <div className="grid grid-cols-2 gap-y-2 gap-x-4">
              {[
                { icon: 'ri-building-line', text: 'Offices at our Venetian 700 Brewery' },
                { icon: 'ri-shield-check-line', text: 'Walk-in and witness shredding' },
                { icon: 'ri-home-line', text: 'Offices at our Venetian (7511 Brewery)' },
                { icon: 'ri-road-map-line', text: 'Street friendly up to R20 WATCH' },
              ].map((item, i) => (
                <div key={i} className="flex items-start gap-2 text-xs text-gray-300">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#74C69D]`}></i>
                  </div>
                  {item.text}
                </div>
              ))}
            </div>
          </div>

          {/* Device types */}
          <div className="grid grid-cols-4 gap-3 mb-6">
            {[
              { icon: 'ri-server-line', label: 'Computer Server\nHard Drive 3.5inch' },
              { icon: 'ri-computer-line', label: 'Laptop Hard\nDrive 2.5inch' },
              { icon: 'ri-hard-drive-2-line', label: 'External\nHard Drive' },
              { icon: 'ri-smartphone-line', label: 'Cell Phone' },
            ].map((d) => (
              <div key={d.label} className="bg-white/10 rounded-lg p-3 text-center">
                <div className="w-8 h-8 flex items-center justify-center mx-auto mb-2">
                  <i className={`${d.icon} text-[#74C69D] text-xl`}></i>
                </div>
                <div className="text-xs text-gray-300 leading-snug whitespace-pre-line">{d.label}</div>
              </div>
            ))}
          </div>

          <Link
            to="/contact"
            className="inline-flex items-center gap-2 bg-[#1B6B3A] text-white font-semibold px-6 py-2.5 rounded-md hover:bg-[#2D8653] transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-arrow-right-circle-line"></i>
            Request Service
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default HardDiskSection;
